import { render, staticRenderFns } from "./genius.vue?vue&type=template&id=712aede6"
import script from "./genius.vue?vue&type=script&lang=js"
export * from "./genius.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports